<ul class="options-menu" @openAnimation [ngStyle]="menuStyle">
   <div (click)="setClose.emit(true)">
      <ng-container *ngTemplateOutlet="content"></ng-container>
   </div>
</ul>
